module.exports = __webpack_public_path__ + "static/media/check.6dc82634.svg";